import React, { useContext, useState,useEffect, useRef, useCallback } from 'react';
import {IProps, IState} from './types';
import {boxesIntersect, SelectionBox} from "react-drag-to-select";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import C from '@assets/themes/colors';
import * as S from './styles';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loading from '@components/Loading';
import { BrandsContext } from '@utils/DOIgnition/BrandsContext';
import { ArrowLeftIcon } from '@assets/icons/arrowLeftIcon';
import Item from '../Item';
import { IType } from '@state/brandsImages/types';
import { validateVehicle } from '@utils/brand'
import { IndexesActions } from '../Item/types';
import RightClickMenu from '@components/RightClickMenu';
import MouseSelection from '@components/MouseSelection';

const ViewAll:React.FC<IProps> = (props) => {
  const [items, setItems] = useState<any>([]);
  const [hasmore, setHasmore] = useState<boolean>(true);
  const paginationNumber = useRef<number>(12);
  const [openOptions, setOpenOptions] = useState(false);
  const [coordinates, setCoordinates] = useState({x: 0, y: 0});
  const [pagination, setPagination]= useState<number|undefined>(undefined);
  const [selectedIndexes, setSelectedIndexes] = useState<number[]>([]);
  const [allowClean, setAllowClean] = useState<boolean>(true);

  const { brandDetail, setViewAll , viewAll, addUpdateBrand, moveFile } = useContext(BrandsContext);
  const scrollDiv = useRef<HTMLDivElement>(null);
  let selectedRefs = React.useRef<(HTMLDivElement | null)[]>([]);
  const stateRef = useRef<boolean>();

  useEffect(() => {
    if (stateRef) stateRef.current = allowClean;
  }, [allowClean]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [])

  const handleSetCoordinates = (e: React.MouseEvent<HTMLDivElement>) => {
    if (openOptions === false)
    {
      let scrollTop = scrollDiv.current?.scrollTop??0;
      setCoordinates({x: e.clientX - 180, y: e.clientY-150 + scrollTop});           
    }
  }

  const handleSelectedIndexes = (index: number, action: IndexesActions) => {
    if (action === 'ADD') {
      setSelectedIndexes([...selectedIndexes, index]);
    } else if (action === 'REMOVE') {
      setSelectedIndexes([...selectedIndexes.filter(selectedIndex => selectedIndex !== index)]);
    }
  }

  const handleClickOutside = (e: any)=> {
    if(selectedRefs && selectedRefs.current){
        const ref: any = selectedRefs.current
        let found = false;
        if (ref) {
          ref.forEach(function (refDesign: any) {
            if (refDesign?.contains(e.target)) found= true;
          });
          setTimeout(() => {
            if (!found && stateRef.current) {
              if (!e.shiftKey){
                setSelectedIndexes([]);
                setOpenOptions(false);
              }
            }
          }, 200)
        }
    }
  }

  const handleSelectionStart = useCallback(
    () => {
      setAllowClean(false);
    },
    []
  );

  const handleSelectionChange = useCallback((box) => {
  }, []);

  const handleSelectionEnd = useCallback(
    (box: SelectionBox) => {
      let indexesToSelect: number[] = [];
      const elementsContainer = document.getElementById("item-list");
      if (elementsContainer) {
        Array.from(elementsContainer.childNodes).forEach((item, index) => {
          const boundingBox = (item as Element).getBoundingClientRect();
          if (boxesIntersect(box, boundingBox)) {
            indexesToSelect.push(index);
          }
        });
      }
      setSelectedIndexes(indexesToSelect);
    },
    []
  );

  useEffect(() => {
    let divList = document.getElementById("infinite-scroll-all-item");
    if (divList) {
      let cols = Math.round((divList.clientWidth - 78)/173);
      let rows = Math.round((divList.clientHeight - 100)/147);
      paginationNumber.current = (rows * (cols+1));
      setPagination(paginationNumber.current);
    } 
  }, []);

  useEffect(() => {
    if (viewAll) {           

      let filterItems = brandDetail?.brand?.[viewAll.section??"logos"].filter((item: any)=>{        
        
        if (viewAll.selectedFilters && viewAll.selectedFilters.length>0)
        {
            let addvalues:any = [];            
            viewAll.selectedFilters.forEach((filter:IType)=>{                
                var itemfilter = item?.[filter.id.includes("type")?"types":"themes"]?.find((f:IType)=>f.id == filter.id);   
                var addval = addvalues.find((f:any)=> f.id==filter.id);                
                let add = itemfilter && itemfilter.value.replace("`","'") == filter.value.replace("`","'");
                if (addval)
                {
                  if (add)
                    addval.add=add;
                }
                else
                {
                  addval = {
                    id:filter.id,
                    add:add
                  }

                  if (filter.id!=="year" && filter.id!=="make" && filter.id!=="model" && filter.id!=="trim")
                    addvalues.push(addval);
                }                                
            })
            
            let additem = addvalues.find((f:any)=>!f.add)
            let addval = false
            
            if (additem==undefined)
              addval =true;
            else
              addval = additem.add;

            let addFilterVehicle = true;
            if (viewAll?.section==="vehicles") {
              let addValYear= validateVehicle(viewAll.selectedFilters, "year", item );
              let addValMake= validateVehicle(viewAll.selectedFilters, "make", item );
              let addValModel= validateVehicle(viewAll.selectedFilters, "model", item );
              let addValTrim = validateVehicle(viewAll.selectedFilters, "trim", item );
              addFilterVehicle = addValYear && addValMake && addValModel && addValTrim && addval ?  true : false;
            }

            return item.status === 'ACTIVE' && addval && addFilterVehicle;

        }
        else
        {     
            let add=true   
            if (viewAll.searchItemsValue && viewAll.searchItemsValue!="") {            
              if (viewAll.section === "fonts" && item.name) {
                add = item.name.toLowerCase().includes(viewAll.searchItemsValue.toLowerCase());
              }
            }
            return item.status === 'ACTIVE' && add  
            
        }
        
      });

        let itemsActive = filterItems.sort(function(a: any,b: any){
        let lastActionA: any=a.actions[a.actions.length-1];
        let lastActionB: any=b.actions[b.actions.length-1];
        return lastActionB && lastActionA &&  new Date(lastActionB.date).valueOf() - new Date(lastActionA.date).valueOf();
      });
      if (paginationNumber && itemsActive.length<=paginationNumber.current) setHasmore(false);
      setItems(itemsActive);
    }
  }, [viewAll,brandDetail?.brand?.[viewAll.section??"logos"]])

  const getTitle = () => {
    if (viewAll?.section && viewAll?.section.substr(viewAll?.section.length - 1) === "s" && viewAll?.section.toLowerCase() !== "fonts" && viewAll?.section.toLowerCase() !== "colors")return viewAll?.section.slice(0, -1)
    else return viewAll?.section??"logo";
  }

  const handleScroll = () => ( pagination && pagination < items.length) ? setPagination(pagination+paginationNumber.current) : setHasmore(false);

  const renderLoaderContainer = () => {
      return(
        <S.LoaderContainer>
          <Loading 
            id={"loading-designs"}
            containerStyle={{justifyContent: 'center'}}
          />
        </S.LoaderContainer>
      );
  }

  let type = viewAll?.section=== "colors" ? "color" : viewAll?.section=== "fonts" ? "font" : "img";

  const renderEndMessage = () => {
    if (type!=="font" && type!=="color")
    {
      return(
          <S.EndMessage>
            There are no more {getTitle()}{type!=="font" && type!=="color" ? " images":""}.
          </S.EndMessage>
      )
    } 
  }
  
  return (
    <S.Root
      id="infinite-scroll-all-item"
      onMouseMove={handleSetCoordinates}
      ref={scrollDiv}
    >
      <S.Container onMouseDown={()=>setAllowClean(true)} >
      <MouseSelection
        onSelectionChange={handleSelectionChange}
        onSelectionEnd={handleSelectionEnd}
        onSelectionStart={handleSelectionStart}
      />
      <S.Back onClick={()=> setViewAll({open: false, section: undefined})}>
          <S.Icon><ArrowLeftIcon fillColor={C.BLUE}/></S.Icon> BACK TO {brandDetail?.brand?.name} BRAND LIBRARY
      </S.Back>
      <S.Title>{getTitle()} {type!=="font" && type!=="color" ? "Images":""}</S.Title>
      {pagination &&
        <InfiniteScroll
          dataLength={items.slice(0,pagination).length}
          next={() => handleScroll()}              
          hasMore={hasmore}
          loader={renderLoaderContainer()}
          scrollableTarget="infinite-scroll-all-item"
          endMessage={renderEndMessage()}
          style={{
            width: '100%',
            minHeight: '200px',
            overflowX: 'hidden',
          }}
        >
          <S.List 
            flex={items?.length}
            fontContainer={type === "font"}
          >
            <TransitionGroup className="group-list" id="item-list">
              { items.slice(0,pagination).map((item: any, index: number) =>
                <CSSTransition key={item.id} timeout={600} classNames="item">
                  <div ref={selectedIndexes.includes(index) ? ref=>selectedRefs.current.push(ref) : null}>
                    <Item 
                      type={type}
                      item={item}
                      index={index}
                      section={viewAll.section??"logos"}
                      selected={selectedIndexes.includes(index)}
                      setOpen={setOpenOptions}
                      handleSelectedIndexes={handleSelectedIndexes}
                    />
                  </div>
                </CSSTransition>
              )} 
            </TransitionGroup>
          </S.List>
        </InfiniteScroll>
      }
      <RightClickMenu
        open={openOptions}
        setOpen={setOpenOptions}
        coordinates={coordinates}
        section={viewAll.section}
        selectedIndexes={selectedIndexes}
        items={items}
        handleWarningScreen={props.handleWarningScreen}
        addUpdateBrand={addUpdateBrand}
        moveFile={moveFile}
      />
      </S.Container>
      
    </S.Root>
  );
}

export default ViewAll;